import r2wc from "@r2wc/react-to-web-component";

import { CustomButton } from "../components/CustomButton";
import "../components/CustomButton.css";

const CustomButtonWebComponent = r2wc(CustomButton, {
  props: {
    label: "string",
    onClick: "function",
    className: "string",
    disabled: "boolean",
  },
});

if (!customElements.get("fm-button")) {
  customElements.define("fm-button", CustomButtonWebComponent);
}
